module.exports = __webpack_public_path__ + "images/category_lp/bike/new/assessment_achievements/1_1ec9805f55eed0e582a6428fb1f19283.png";